var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{staticClass:"all-items",attrs:{"items":_vm.data.rows,"fields":_vm.fields,"striped":"","hover":"","responsive":""},scopedSlots:_vm._u([{key:"cell(AttemptCounter)",fn:function(data){return [_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(data.value)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }